import React from "react";
import CommonCard from "components-v2/kpi/common-card";
import { useQuery } from "@tanstack/react-query";
import { apiRoot } from "services/src/config";
import { HOME_CARD_CONTENT } from "@/modules/home/constants";
import { ShimmerEffect } from "components/shimmer";

export default function MarginAdherenceCard({ onClick, tagId }) {
    const { data, isLoading } = useQuery({
        queryKey: ["margin-adherence-default", tagId],
        queryFn: async () => {
            const params = new URLSearchParams();
            if (tagId) params.append("tagId", tagId);
            const queryString = params.toString();
            const endpoint = `kpi/margin-adherence-default${queryString ? `?${queryString}` : ""}`;
            const response = await apiRoot.get(endpoint);
            return response.data.data;
        },
    });

    if (!data) return null;

    const marginAdherence = data?.margin_adherence ?? 0;
    const budgetMargin = data?.period_budget_margin ?? 0;
    const achievedMargin = data?.period_achieved_margin ?? 0;
    const billableRevenue = data?.period_billable_revenue;
    const billedRevenue = data?.period_billed_revenue;
    const actualCost = data?.period_actual_cost;
    const jobCount = data?.job_count ?? 0;

    const { title, description } = HOME_CARD_CONTENT.marginAdherence;

    return (
        <CommonCard
            title={title}
            info={description}
            onClick={onClick}
            cardData={{
                title: title,
                description: description,
                value: isLoading ? "0" : marginAdherence,
                unit: "",
                details: [
                    { label: "Budget Margin", value: budgetMargin },
                    { label: "Achieved Margin", value: achievedMargin },
                    { label: "Job Count", value: jobCount },
                    billableRevenue != null && { label: "Billable Revenue", value: billableRevenue },
                    billedRevenue != null && { label: "Billed Revenue", value: billedRevenue },
                    actualCost != null && { label: "Actual Cost", value: actualCost },
                ].filter(Boolean),
            }}
        >
          <div className="text-3xl font-bold mt-2">
            {isLoading ? (
              <ShimmerEffect className="h-10 w-32" />
            ) : (
                <>
                    {marginAdherence}
                </>
            )}
          </div>
        </CommonCard>
    );
}
